export default __webpack_public_path__ + "static/media/JO.13171a48.svg";